import { createAction, createSlice, PrepareAction } from '@reduxjs/toolkit';
import { UserModel } from '@app/interfaces/interfaces';

export interface UserState {
  user: UserModel | null;
}

const initialState: UserState = {
  user: null,
};

export const setUser = createAction<PrepareAction<UserModel>>('user/setUser', (newUser) => {
  return {
    payload: newUser,
  };
});

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setUser, (state, action) => {
      state.user = action.payload;
    });
  },
});

export default userInfoSlice.reducer;
